import React from 'react';

import { getConfig } from '@micro-apps/env';

const { IMAGE_BASE_URL, DEFAULT_IMAGE_PATH } = getConfig(process.env);

const getImageSrc = (src: string) => (src.startsWith('http') ? src : (IMAGE_BASE_URL || '') + src);

export default function Image({ src, alt, ...props }) {
	const defaultImagePath = getImageSrc(
		props?.['defaultImagePath'] ??
			DEFAULT_IMAGE_PATH ??
			'/content/dam/fourseasons/images/web/FSH/FSH_no_image_light_grey_tree_aspect16x9.jpg'
	);
	return (
		<img
			src={src ? getImageSrc(src) : defaultImagePath}
			{...props}
			alt={alt}
			onError={
				props['onError']
					? props['onError']
					: e => {
							const img = e.target as HTMLImageElement;
							if (!img.src.endsWith(defaultImagePath)) {
								img.src = defaultImagePath;
							}
						}
			}
		/>
	);
}
